import React from 'react';
import { useTranslation } from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { setLanguageISO } from '../redux/actions';
import { useAppDispatch, useAppSelector } from '../redux/ReduxProvider';

const LanguageSelect = (props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { selectedLanguage, languages } = useAppSelector(({ languages }) => ({
    selectedLanguage: languages.selectedLanguage,
    languages: languages.languages,
  }));

  const onChangeLanguage = ({ target }) => {
    const langISOCode = target.value;
    dispatch(setLanguageISO(langISOCode));
  };

  if (!selectedLanguage || !languages || languages.length <= 1) {
    return null;
  }

  const sortedLanguages = [...languages].sort((a, b) =>
    t('survey.language.' + a.langISOCode).localeCompare(t('survey.language.' + b.langISOCode)),
  );

  return (
    <FormControl variant="standard" {...props}>
      <Select variant="standard" value={selectedLanguage.langISOCode} onChange={onChangeLanguage} disableUnderline>
        {sortedLanguages.map((language) => (
          <MenuItem key={language.langISOCode} value={language.langISOCode}>
            {t('survey.language.' + language.langISOCode)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelect;
